// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PieChart_wrapper__11B2s","rate":"PieChart_rate__2wlwI","count":"PieChart_count__x05fO","line":"PieChart_line__dNA8G","length":"PieChart_length__3XbGH"};